function retrieveDepositFraction(companyId) {
    return window.tenantAxios.get(`/company/${companyId}/deposit-fraction`);
}

function updateDepositFraction(companyId, depositFraction) {
    return window.tenantAxios.patch(`/company/${companyId}/deposit-fraction`, depositFraction);
}

export default {
    retrieveDepositFraction,
    updateDepositFraction,
};
